import * as qs from "querystring";
import * as jwt from "jsonwebtoken";
import { ssoLogOffURL } from "./WebHelper";

export const TOKEN_STORE_NAME = "USER_TOKEN";

export class AuthHelper {
  public static UserHasToken(): boolean {
    const tokenMatches = /\?t=(.+)$/.exec(window.location.href);
    const tokenQuery: any = tokenMatches ? tokenMatches[1] : null;
    // const tokenQuery: any = qs.parse(location.search)["?t"];
    if (tokenQuery !== null) {
      // save token to localstorage
      this.SetUserToken(tokenQuery);

      // Clean the URL so that we dont show the token.
      // can be comented out if debugging.
      const uri = window.location.toString();
      if (uri.indexOf("?t") > 0) {
        const cleanUri = uri.substring(0, uri.indexOf("?t"));
        window.history.replaceState({}, document.title, cleanUri);
      }
      return true;
    }

    const tokenLocal = localStorage.getItem(TOKEN_STORE_NAME);
    // check if we have the token in the local store.
    if (tokenLocal !== null) {
      try {
        jwt.verify(tokenLocal, "secretKeyMustBeGraterThan128Bits");
      } catch (e) {
        return false;
      }
      return true;
    }

    return false; // else we redirect to SSO: return false
  }
  // this should be present on the user.
  public static GetUserToken(): any {
    if (this.UserHasToken()) {
      const token = localStorage.getItem(TOKEN_STORE_NAME);
      return token;
    }
  }
  public static GetUserIdFromToken(): any {
    const token = localStorage.getItem(TOKEN_STORE_NAME);
    if (token !== null) {
      const decoded = jwt.decode(token, { complete: true });
      if (decoded !== null) {
        const userId =
          decoded["payload"][
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
          ];
        return userId;
      }
    }
  }

  public static SetUserToken(token: string) {
    localStorage.setItem(TOKEN_STORE_NAME, token);
  }

  public static GetUserRoles() {
    // get the users roles from the token
  }

  public static LogOff() {
    // Todo: handel timeout redirect so the user gets the correct msg.
    localStorage.removeItem(TOKEN_STORE_NAME);
    // localStorage.clear();
    window.location.replace(ssoLogOffURL);
  }

  public static UserIsAuthenticated() {
    // check if the users token is valid and that it exsists
    //
  }
}



// WEBPACK FOOTER //
// ./src/helpers/AuthHelper.ts